import { B_ORDER_YS } from '@/business'
import { isEmptyObject, isNonEmptyArray, isNullOrEmpty } from '@/utils'

/**
 * 月嫂服务时间
 */
export function getServiceTime(order) {
  const { orderState, extInfo } = order
  let str = ''
  if (isNonEmptyArray(extInfo)) {
    let serviceTimeObj = extInfo.find(x => x.labelKey === 'serviceTime')
    if (!isEmptyObject(serviceTimeObj)) {
      str = serviceTimeObj.labelValue || ''
    }
  }
  if (isNullOrEmpty(str)) {
    const workState = B_ORDER_YS.getWorkState(order)
    if (B_ORDER_YS.isInService(orderState, workState)) {
      str = B_ORDER_YS.getBarCodeInfo(order).confirmHouseHoldTime
    } else if (B_ORDER_YS.isHomeApplied(orderState, workState)) {
      str = B_ORDER_YS.getBarCodeInfo(order).applyHouseHoldTime
    }
  }
  return str
}

export function getAdress(order) {
  const { collectInfo } = order
  if (!isNullOrEmpty(collectInfo)) {
    const d = collectInfo.deliveryAddr
    if (!isEmptyObject(d)) {
      const adressInfo = d.reqParam
      if (!isEmptyObject(adressInfo)) {
        return adressInfo
      }
    }
  }
  return {}
}
